import axios from "axios";
import { getAuthHeaders } from "../Api";
import {
  IdeaCustomization,
  IdeaCustomizationCreateParams,
  IdeaCustomizationUpdateParams,
  IdeaPerspectivesUpdateParams,
  IdeaFiltersUpdateParams,
  IdeaColumnsUpdateParams,
  IdeaInfoTabsUpdateParams,
  IdeaPerspective,
  IdeaFilter,
  IdeaColumn,
  IdeaInfoTab,
  Customization
} from '@bageltechnologies/bagel-common';

// Additional interfaces not available in bagel-common
export interface AvailablePerspective {
  key: string;
  label: string;
}

// Interfaces
export interface Perspective {
  label: string;
  key: string;
  countType: string;
  fieldPath?: string;
}

export interface FilterOperation {
  name: string;
  label: string;
}

export interface Filter {
  name: string;
  label: string;
  type: 'number' | 'checkbox' | 'date' | 'boolean' | 'userIdIn' | 'fetchableCheckbox' | 'parent';
  filterObject: 'idea' | 'evidence';
  operations?: FilterOperation[];
  dbFieldPath: string;
  // Additional optional properties can be added here
  [key: string]: any;
}

const API_DOMAIN = window.__RUNTIME_CONFIG__.REACT_APP_API_DOMAIN;
const API_BASE_URL = `${API_DOMAIN}/customizations-config`;

// Main Customization Operations
export const getCustomizations = async (auth0: any) => {
  try {
    const config = await getAuthHeaders(auth0);
    const response = await axios.get(`${API_BASE_URL}`, config);
    return response.data;
  } catch (e) {
    console.error("Error fetching customizations", e);
    throw e;
  }
};

export const getCustomization = async (auth0: any) => {
  try {
    const config = await getAuthHeaders(auth0);
    const response = await axios.get(`${API_BASE_URL}/idea`, config);
    return response.data;
  } catch (e) {
    console.error("Error fetching customization", e);
    throw e;
  }
};

export const createCustomization = async (customization: IdeaCustomizationCreateParams, auth0: any) => {
  try {
    const config = await getAuthHeaders(auth0);
    const response = await axios.post(`${API_BASE_URL}`, customization, config);
    return response.data;
  } catch (e) {
    console.error("Error creating customization", e);
    throw e;
  }
};

export const updateCustomization = async (customization: IdeaCustomizationUpdateParams, auth0: any) => {
  try {
    const config = await getAuthHeaders(auth0);
    const response = await axios.put(`${API_BASE_URL}/idea`, customization, config);
    return response.data;
  } catch (e) {
    console.error("Error updating customization", e);
    throw e;
  }
};

export const deleteCustomization = async (auth0: any) => {
  try {
    const config = await getAuthHeaders(auth0);
    const response = await axios.delete(`${API_BASE_URL}/idea`, config);
    return response.data;
  } catch (e) {
    console.error("Error deleting customization", e);
    throw e;
  }
};

// Section-Specific Operations

// Perspectives
export const getAvailablePerspectives = async (auth0: any) => {
  try {
    const config = await getAuthHeaders(auth0);
    const response = await axios.get(`${API_BASE_URL}/idea/available-perspectives`, config);
    return response.data;
  } catch (e) {
    console.error("Error fetching available perspectives", e);
    throw e;
  }
};

export const getPerspectives = async (auth0: any) => {
  try {
    const config = await getAuthHeaders(auth0);
    const response = await axios.get(`${API_BASE_URL}/idea/perspectives`, config);
    return response.data;
  } catch (e) {
    console.error("Error fetching perspectives", e);
    throw e;
  }
};

export const updatePerspectives = async (data: IdeaPerspectivesUpdateParams, auth0: any) => {
  try {
    const config = await getAuthHeaders(auth0);
    const response = await axios.put(`${API_BASE_URL}/idea/perspectives`, data, config);
    return response.data;
  } catch (e) {
    console.error("Error updating perspectives", e);
    throw e;
  }
};

export const deletePerspective = async (perspectiveKey: string, auth0: any) => {
  try {
    const config = await getAuthHeaders(auth0);
    const response = await axios.delete(`${API_BASE_URL}/idea/perspectives/${perspectiveKey}`, config);
    return response.data;
  } catch (e) {
    console.error("Error deleting perspective", e);
    throw e;
  }
};

// Filters
export const getFilters = async (auth0: any) => {
  try {
    const config = await getAuthHeaders(auth0);
    const response = await axios.get(`${API_BASE_URL}/idea/filters`, config);
    return response.data;
  } catch (e) {
    console.error("Error fetching filters", e);
    throw e;
  }
};

export const updateFilters = async (data: IdeaFiltersUpdateParams, auth0: any) => {
  try {
    const config = await getAuthHeaders(auth0);
    const response = await axios.put(`${API_BASE_URL}/idea/filters`, data, config);
    return response.data;
  } catch (e) {
    console.error("Error updating filters", e);
    throw e;
  }
};

export const updateFilter = async (data: any, auth0: any) => {
  try {

    console.log('data in api')

    console.log(data)


    const config = await getAuthHeaders(auth0);


    const response = await axios.put(`${API_BASE_URL}/idea/filter`, data, config);
    return response.data;
  } catch (e) {
    console.error("Error updating filters", e);
    throw e;
  }
};

// Idea Columns
export const getIdeaColumns = async (auth0: any) => {
  try {
    const config = await getAuthHeaders(auth0);
    const response = await axios.get(`${API_BASE_URL}/idea/columns`, config);
    return response.data;
  } catch (e) {
    console.error("Error fetching idea columns", e);
    throw e;
  }
};

export const updateIdeaColumns = async (data: IdeaColumnsUpdateParams, auth0: any) => {
  try {
    const config = await getAuthHeaders(auth0);
    const response = await axios.put(`${API_BASE_URL}/idea/columns`, data, config);
    return response.data;
  } catch (e) {
    console.error("Error updating idea columns", e);
    throw e;
  }
};

// Info Tabs
export const getInfoTabs = async (auth0: any) => {
  try {
    const config = await getAuthHeaders(auth0);
    const response = await axios.get(`${API_BASE_URL}/idea/info-tabs`, config);
    return response.data;
  } catch (e) {
    console.error("Error fetching info tabs", e);
    throw e;
  }
};

export const updateInfoTabs = async (data: IdeaInfoTabsUpdateParams, auth0: any) => {
  try {
    const config = await getAuthHeaders(auth0);
    const response = await axios.put(`${API_BASE_URL}/idea/info-tabs`, data, config);
    return response.data;
  } catch (e) {
    console.error("Error updating info tabs", e);
    throw e;
  }
};